<template>
    <div id="content">
        <link rel="stylesheet" href="/themes/ito/css/parents.css">
        <link rel="stylesheet" href="/themes/ito/css/upgrade-feature.css">

        <div class="container" v-if="!doPlacementTest">
            <div id="page-header-fixed" class="mb-25">
                <div class="container">
                    <div id="page-header">
                        <div class="buttons">
                            <UpgradeNavTabs />
                        </div>
                    </div>
                </div>
            </div>
            <div id="upgrade-detail" class="card card-comments" style="color: #000; font-size: 16px;">
                <div class="card-body" style="padding: 0;border-radius: 8px;">
                    <h5 class="card-title" style="background: #FFE39B;padding: 12px 30px; margin: 0;border-radius: 8px 8px 0px 0px;">
                        <span class="title fw-bold">{{ title }}</span>
                    </h5>

                    <div class="card-content">
                        <template v-if="packages_list.length > 0">
                            <div v-if="step == 1">
                                <div class="select-upgrade-type payment-packages">
                                    <div class="list-package">
                                        <template v-for="(pkg, index) in packages_list">
                                            <div class="package">
                                                <input :id="'pkg' + index" name="package_select" type="radio" v-model="package_select" :value="pkg.code" />
                                                <label :for="'pkg' + index" class=" box-shadow-main">
                                                    <div class="payment-package-item" :class="package_select == pkg.code ? 'active' : ''">
                                                        <div class="title">{{ pkg.name }}</div>
                                                        <div class="desc">{{ pkg.price | toCommas }}<span class="sm-text">{{$t('month')}}</span></div>
                                                        <div class="desc-box">
                                                            <div class="desc-box-item" v-for="(desc, descIndex) in packages_list[index].desc" :key="descIndex">
                                                                <img :src="activeIcon" /> {{ desc }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </label>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                <div class="col-md-12 text-center">
                                    <button class="btn btn-main" :class="{ 'disabled': packages_list.length === 0 }" style="padding: 8px 60px;" @click="packages_list.length ? gotoStep(2, package_select) : null">
                                        {{$t('upgrade_account')}}
                                    </button>
                                </div>
                            </div>
                            <div v-if="step == 2">
                                <UpgradeFeatureDetail :package_select="package_select" :products_list="products_list" @updateStep="updateStep" />
                            </div>
                            <div v-if="step == 3">
                                <UpgradeFeaturePayment :package_select="package_select" :showInfo="showInfo" :gates="gates" @updateStep="updateStep" />
                            </div>
                        </template>
                        <template v-else>
                            <p class="text-center p-5">{{ $t('empty_data') }}</p>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { toCommas } from '../../utils/utils'
import { mapGetters } from 'vuex'
import { getFeature, postPayment } from "../../models/payment";
import activeIcon from '../../../public/themes/ito/images/icons/active-tick.svg';
import UpgradeFeatureDetail from "./UpgradeFeatureDetail.vue";
import UpgradeFeaturePayment from "./UpgradeFeaturePayment.vue";
import UpgradeNavTabs from "./UpgradeNavTabs.vue";

export default {
    name: "UpgradeFeature",
    title: 'Upgrade Feature',
    components: {
        UpgradeNavTabs,
        UpgradeFeatureDetail,
        UpgradeFeaturePayment
    },
    data() {
        return {
            activeIcon,
            title: '',
            gates: [],
            products_list: [],
            packages_list: [],
            featureNameMap: {
                'speak_ai_attempt': 'AI Speak PRO',
                'ai_home_tutor': 'AI Tutor PRO'
            },
            featureKeyMap: {
                'speak_ai_attempt': 'ai_speak_pro_package_desc',
                'ai_home_tutor': 'ai_tutor_pro_package_desc'
            },
            featureCodes: ['speak_ai_attempt', 'ai_home_tutor'],
            product: '',
            package_select: 'speak_ai_attempt',
            method: '',
            voucher: 'xxx',
            step: 1
        };
    },

    created() {
        this.title = this.$t('unclock_full_access');
        this.$store.commit('setMenuActive', 'parent');

        const featureCode = this.$route.query.feature_code || null;

        this.fetch().then(() => {
            if (featureCode !== null) {
                this.gotoStep(2, featureCode);
            }
        });
    },

    watch: {
        '$route.query.feature_code'(newFeatureCode) {
            if (newFeatureCode) {
                if (newFeatureCode === 'speak_ai_attempt') {
                    this.title = 'AI Speak PRO';
                }
                else if (newFeatureCode === 'ai_home_tutor') {
                    this.title = 'AI Tutor PRO';
                }
            }
            else {
                this.title = this.$t('unclock_full_access');
                this.gotoStep(1);
            }
        },
        package_select() {
            this.product = '';
            this.method = '';
        },
        product() {
            this.method = '';
        }
    },
    computed: {
        ...mapGetters([
            'user_info'
        ], () => {
            if (this.user_info) {
                return this.user_info
            }

            return this.user
        }),
        doPlacementTest() {
            return this.user_info.placement_test === 0 && this.user_info.student_type !== 1;
        }
    },

    methods: {
        fetch() {
            const that = this;
            that.$store.commit("setLoading", true);

            return axios.all([
                getFeature(),
            ]).then(axios.spread((package_response) => {
                that.$store.commit("setLoading", false);

                if (package_response.data.code != 0) {
                    return;
                }
                that.products_list = package_response.data.results.packages?.[0].products || [];
                that.setupPackages();
                that.gates = package_response.data.results.gate || [];
            }));
        },
        setupPackages() {
            this.products_list.forEach((product) => {
                const existedProduct = this.packages_list.find(p => p.code === product.feature_code);
                if (!existedProduct) {
                    const packageDesc = [];
                    for (let i = 1; i <= 5; i++) {
                        if (this.$te(`${this.featureKeyMap[product.feature_code]}${i}`)) {
                            packageDesc.push(this.$t(`${this.featureKeyMap[product.feature_code]}${i}`));
                        }
                    }
                    this.packages_list.push({
                        code: product.feature_code,
                        name: this.featureNameMap[product.feature_code] || '',
                        price: product.desc.price_month,
                        desc: packageDesc
                    });
                    return;
                }
                if (existedProduct.price > product.desc.price_month) {
                    existedProduct.price = product.desc.price_month;
                }
            });
            this.package_select = this.packages_list.length > 0 ? this.packages_list[0].code : '';
        },
        gotoStep(step, featureCode = null) {
            if (step === 1) {
                if (this.$route.query.feature_code) {
                    this.$router.push({
                        path: `/upgrade-feature`
                    });
                }
            }
            if (step === 2 && featureCode !== null) {
                if (this.featureCodes.find(code => code === featureCode)) {
                    this.package_select = featureCode;
                    if (!this.$route.query.feature_code) {
                        this.$router.push({
                            path: `/upgrade-feature?feature_code=${featureCode}`
                        });
                    }
                }
                else {
                    this.$router.push({
                        path: `/upgrade-feature`
                    });
                    return;
                }
            }
            if (step === 4) {
                this.Payment();
                return;
            }
            this.step = step;
        },
        updateStep(step, product = '', method = '', voucher = 'xxx') {
            if (method === '') {
                this.product = product;
            }
            this.method = method;
            if (voucher !== '') {
                this.voucher = voucher;
            }
            this.gotoStep(step);
        },
        showInfo(field) {
            for (const item of this.products_list) {
                if (item.product_id != this.product) {
                    continue;
                }
                if (field === 'name') {
                    return item.product_name;
                }
                if (field === 'price') {
                    // return `${toCommas(item.price)}đ (${toCommas(item.desc.price_month)}đ${this.$t('month')})`;
                    return `${toCommas(item.price)} đ`;
                }
            }
        },
        Payment() {
            const that = this;

            that.$store.commit("setLoading", true);
            const formData = new FormData();
            formData.append('product_id', this.product);
            formData.append('voucher', this.voucher);
            formData.append('method', this.method);
            postPayment(formData).then((data) => {
                that.$store.commit("setLoading", false);
                if (data.data.code == 0) {
                    window.location.href = data.data.results.url;
                } else {
                    alert(data.data.results);
                }
            }).catch(({ response }) => {
                that.$store.commit("setLoading", false);
                console.log('ect', response);
                alert(response.data.results);
            });
        }
    }
}
</script>

<style scoped>
[type="radio"]:not(:checked),
[type="radio"]:checked {
    position: absolute;
    opacity: 0;
    pointer-events: none;
}

.package {
    width: 400px !important;
}

.select-upgrade-type [type=radio]:checked + label {
    background: #E98437;
}

.box-shadow-main {
    /*box-shadow: 4px 4px rgba(0, 0, 0, 0.07);*/
    border-radius: 8px;
    box-shadow: 4px 4px 0px rgba(0, 0, 0, 0.07), inset 0px 4px 0px rgba(231, 231, 231, 0.25);
}

.package{
    padding: 0;
}

.list-package{
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    /* flex-wrap: wrap; */
    overflow-x: auto;
}

.payment-package-item{
    width: 400px;
    /* height: unset; */
}

.payment-packages .payment-package-item .desc-box{
    height: 400px;
    max-height: 510px;
    /* min-height: 310px; */
    overflow-y: auto;
}

.payment-packages{
    margin: 0;
}

.desc-box{
    margin-bottom: 0 !important;
}

.container{
    width: 942px;
    padding: 0;
}
</style>